import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { Refresh } from 'mdi-material-ui'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'

const PointConfigToolbar = props => {
    const { numSelected, selected } = props

    const UpdateConfig = async () => {
        selected.forEach(async item => {
            try {
                await apiService.put(`/pointcfg/${item.id}`, {
                    "point": item.point,
                    "active": item.active ? 1:0,
                    "expire": item.expire,
                });
                toast.success('수정 되었습니다');
            } catch (error) {
                console.error(error);
            }
        });
    }

    return (
        <Box
            sx={{
                p: 2,
                pb: 0,
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                flexDirection: 'row'
            }}
        >
            <Box sx={{ display: 'flex' }}>
            {numSelected > 0 ? (
                <Tooltip title='Update'>
                    <IconButton sx={{ color: '#006A4E' }} onClick={UpdateConfig} >
                        <Refresh />
                    </IconButton>
                </Tooltip>                    
                ) : null}
            </Box>
        </Box>
    )
}

export default PointConfigToolbar
